import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import type { LC_SaveGroupAdminsIn } from '../types/groupAdmins.types';


export class GroupAdminsSaveService {
  async save(
    groupId: number,
    body: LC_SaveGroupAdminsIn,
  ): Promise<ApiResponse<void>> {
    return apiClient.put<void>(
      API_CONFIG.ENDPOINTS.SECURITY_GROUPING.ADMINS(groupId),
      body,
    );
  }
}

export const groupAdminsSaveService = new GroupAdminsSaveService();
